/** Stable public asset paths (not hashed) — survive Hostinger deploys reliably. */
const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

export const brandLogo = `${base}/brand/logo.png`;
export const brandHeart = `${base}/brand/heart.png`;
export const brandCpl1 = `${base}/brand/cpl1.jpg`;
export const brandCpl2 = `${base}/brand/cpl2.jpg`;
export const brandCpl3 = `${base}/brand/cpl3.jpg`;
export const brandCpl4 = `${base}/brand/cpl4.jpg`;
export const brandFallback = `${base}/default.jpg`;
